<div style="padding: 20px 10px 15px 10px; background-color: #e2e2e2; margin-bottom: 10px;">
<div style="display:none">{{fields[0].props.changeDetect|async}}</div>
<div class="control-attributes active-control">
  <h3>{{componentForm.get('label').value}}</h3>
  <h3>Required Photo # {{componentForm.get('minimumPhotoCount').value}}</h3>
  <h3>Maximum Photo # {{componentForm.get('maximumPhotoCount').value}}</h3>
  <img src="/assets/add_image.png" width= "150">
</div>
</div>
